package fr.manyverse.app.domain.model

enum class OAuthProvider {
    GOOGLE,
    APPLE
}
